module.exports = __webpack_public_path__ + "static/img-mikrotron-919a739ecb28a63cd66d05bdbfb04f28.png";